// src/CameraFill.tsx
import * as React from "react";
var CameraFill = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size * 1.25,
    height: props.size,
    viewBox: "0 0 20 16",
    fill: props.color,
    style: props.style,
    role: props.role,
    className: props.className
  },
  /* @__PURE__ */ React.createElement("path", { d: "M15.6 3.1h-2.22l-.87-.94c-.26-.29-.64-.46-1.03-.46H8.52c-.39 0-.77.17-1.04.46l-.86.94H4.4c-.77 0-1.4.63-1.4 1.4v8.4c0 .77.63 1.4 1.4 1.4h11.2c.77 0 1.4-.63 1.4-1.4V4.5c0-.77-.63-1.4-1.4-1.4zM10 12.2c-1.93 0-3.5-1.57-3.5-3.5S8.07 5.2 10 5.2s3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5zm0-1.4a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2z" })
);
CameraFill.displayName = "CameraFill";
export {
  CameraFill
};
